import { render, staticRenderFns } from "./incomeStatistics.vue?vue&type=template&id=2b71bac8&scoped=true"
import script from "./incomeStatistics.vue?vue&type=script&lang=js"
export * from "./incomeStatistics.vue?vue&type=script&lang=js"
import style0 from "./incomeStatistics.vue?vue&type=style&index=0&id=2b71bac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71bac8",
  null
  
)

export default component.exports